import { ABTesting } from '../frameworks_drivers/redux/reducers/abTest/abTesting';
import { MiscStoreData } from '../frameworks_drivers/redux/reducers/miscellaneous/miscSlice';
import { RadioOptionKeys } from '../tools/RadioOptionMapper';
import { BuildMetaArrayUseCase } from '../application/use_cases/BuildMetaArrayUseCase';
import { QueryParamAdapter } from '../interface_adapters/QueryParamAdapter';
import { AbTestingAdapter } from '../interface_adapters/AbTestingAdapter';
import { FastLaneAdapter } from '../interface_adapters/FastLaneAdapter';
import { ExtractAwinInformation } from '../application/use_cases/ExtractAwinInformation';

export class PayloadBuilder {
  public static buildPayloadFromStoreData(
    storeData: any,
    abTesting: ABTesting,
    miscData: MiscStoreData
  ) {
    const useCase = new BuildMetaArrayUseCase(
      new QueryParamAdapter(),
      new AbTestingAdapter(abTesting),
      new FastLaneAdapter()
    );

    const awinInformationExtractor = new ExtractAwinInformation(new QueryParamAdapter());
    const awinConversionId = awinInformationExtractor.extract('awc');

    const payload: any = {
      contactCustomer: {
        email: storeData.contactDetails.email,
        firstName: storeData.contactDetails.fname,
        lastName: storeData.contactDetails.lname,
        phoneNumber: storeData.contactDetails.phone,
        gender: storeData.contactDetails.gender
      },
      addressInvoice: {
        firstName: storeData.contactDetails.fname,
        lastName: storeData.contactDetails.lname,
        zip: storeData.invoiceAddress.zip,
        street: storeData.invoiceAddress.street,
        city: storeData.invoiceAddress.city,
        houseNr: storeData.invoiceAddress.houseNumber
      },
      addressProperty: {
        zip: storeData.houseAddress.zip,
        street: storeData.houseAddress.street,
        city: storeData.houseAddress.city,
        houseNr: storeData.houseAddress.houseNumber
      },
      propertyDetails: {
        numberOfApartments: storeData.numberOfApartments,
        heatingCostsInvoice: storeData.heatingCostsInvoice,
        centralHeatingAvailable:
          storeData.centralHeatingAvailable === RadioOptionKeys.CentralHeatingAvailable.Yes,
        centralHotWaterDelivery:
          storeData.centralHotWaterDelivery === RadioOptionKeys.HotWaterDeliveryCentral.Yes,
        heatingType: storeData.heatingType,
        heatingSources: storeData.heatingSources
      },
      billingPeriod: {
        ...storeData.billingPeriod
      },
      consentAgreement: storeData.givenConsents,
      marketingConsent: storeData.marketingConsent,
      products: storeData.selectedProducts,
      meta: useCase.execute(),
      discountCode: miscData.referralDiscountCode
    };

    if (awinConversionId) {
      payload.awinConversionId = awinConversionId;
    }

    return payload;
  }
}
